module.exports = __webpack_public_path__ + "img/only-phone.7aade40e.svg";